import { http } from "./api";

const KEY = "al_voter_id";
export const voterId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "");
    localStorage.setItem(KEY, id);
  }
  return id;
};

export async function fetchIdeas(source) {
  try {
    const res = await http.get("/ideas", { params: { source, voter_id: voterId() } });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

export const castVote = (id, value) => http.post(`/ideas/${id}/vote`, { voter_id: voterId(), value });
